import React from 'react'

const NotesContractualWizard = ({ comment, setComment }: any) => {
  return (
    <div className='row'>
      <div className='col-md-12'>
        <label>Comments </label>
        <textarea
          rows={4}
          style={{ width: '100%' }}
          value={comment}
          onChange={(e: any) => setComment(e.target?.value)}
        />
      </div>
    </div>
  )
}

export default NotesContractualWizard